import { useGenericForm } from '@/hooks/use-generic-form';
import {
  adminChangePasswordSchema,
  changePasswordSchema,
} from '@/validation/change-password.schema';
import { AxiosError } from 'axios';
import { z } from 'zod';
import {
  useAdminChangePassword,
  useChangePassword,
} from '@/api/user/user.hooks.ts';
import { BasicResponse } from '@/api/common/common.types.ts';

type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;

export const useChangePasswordForm = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (response: BasicResponse) => void;
  onError?: (error: AxiosError<any>) => void;
}) => {
  const changePasswordMutation = useChangePassword();

  return useGenericForm<ChangePasswordFormData, BasicResponse>({
    schema: changePasswordSchema,
    mutation: changePasswordMutation,
    onSuccess,
    onError,
  });
};

type AdminChangePasswordFormData = z.infer<typeof adminChangePasswordSchema>;

export const useAdminChangePasswordForm = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (response: BasicResponse) => void;
  onError?: (error: AxiosError<any>) => void;
}) => {
  const changePasswordMutation = useAdminChangePassword();

  return useGenericForm<AdminChangePasswordFormData, BasicResponse>({
    schema: adminChangePasswordSchema,
    mutation: changePasswordMutation,
    onSuccess,
    onError,
  });
};
